import { FormContainer, IconButton, SendIcon, Stack, TextField } from '@all-manager/design-system-v2';
import { useChatComposer } from './useChatComposer';

type Props = {
  onSubmit: (text: string) => void;
  disabled?: boolean;
};

const MAX_ROWS = 6;

export default function ChatComposer(props: Props) {
  const hook = useChatComposer(props);

  return (
    <FormContainer onSubmit={hook.handleSubmit} noValidate aria-label="Poser une question à l'assistant">
      <Stack direction="row" spacing={1} alignItems="flex-end">
        <TextField
          label="Votre question"
          placeholder="Ex : Quand est prévue la prochaine AG ?"
          value={hook.draft}
          onChange={hook.handleChange}
          onKeyDown={hook.handleKeyDown}
          disabled={props.disabled}
          helperText="Réponses générées par l'IA à partir des données de la copropriété : vérifiez les sources."
          multiline
          maxRows={MAX_ROWS}
          fullWidth
        />
        <IconButton
          type="submit"
          color="primary"
          size="large"
          tooltip="Envoyer"
          aria-label="Envoyer la question"
          disabled={!hook.canSubmit}
        >
          <SendIcon />
        </IconButton>
      </Stack>
    </FormContainer>
  );
}
